import {
  HStack,
  Stack,
  Text,
  IconButton,
  Image,
  Box,
  Switch,
  Icon,
  Divider,
  chakra,
  VStack,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";
import { FaGripVertical } from "react-icons/fa";
import { FiEdit2, FiActivity } from "react-icons/fi";
import {
  DragControls,
  Reorder,
  useMotionValue,
  useDragControls,
} from "framer-motion";

const ListItem = chakra(Reorder.Item);

export const FeedItem = (props: {
  item: KYDAdminFeedItem;
  onUpdate: (key: string, update?: any) => void;
  onEdit: (item: KYDAdminFeedItem) => void;
  loading: any;
}) => {
  const dragControls = useDragControls();
  const y = useMotionValue(0);

  const handleMouseDownReorder = useCallback(
    (e: React.PointerEvent, item: KYDAdminFeedItem, dc: DragControls) => {
      console.log("mouse down");
      dc.start(e);
      document.addEventListener(
        "mouseup",
        () => {
          console.log("mouse up");
          const order = item.type === "news" ? "news_order" : "music_order";
          console.log("New Order: ", order);
          props.onUpdate(order);
        },
        { once: true }
      );
    },
    [props]
  );

  return (
    <ListItem
      id={props.item.id}
      value={props.item.id}
      dragListener={false}
      style={{ y }}
      dragControls={dragControls}
      bg="white"
    >
      <Box
        w="100%"
        borderWidth={"1px"}
        rounded={"md"}
        borderColor="gray.300"
        px={{ base: 1, md: 3 }}
        py={{ base: 2, md: 3 }}
      >
        <HStack w="100%" justify={"space-between"}>
          <HStack w="100%">
            {props.item.type !== "external_event" ? (
              <HStack
                display={{ base: "none", md: "inherit" }}
                cursor={"grab"}
                onPointerDown={(e) => {
                  handleMouseDownReorder(e, props.item, dragControls);
                }}
                h="100px"
                w={["40px", null, "25px"]}
                justify={"center"}
              >
                <Icon color="gray.400" as={FaGripVertical} />
              </HStack>
            ) : null}

            <Stack w="100%">
              <HStack w="100%">
                <Image
                  rounded="md"
                  src={props.item.image}
                  maxW={{ base: "50px", md: "100px" }}
                />
                <Stack spacing={0}>
                  <a
                    href={props.item.original_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Text fontWeight="medium">{props.item.title}</Text>
                  </a>
                  <Text fontSize={"xs"} color="gray.700">
                    {props.item.description}
                  </Text>
                </Stack>
              </HStack>
              <Divider />
              <HStack w="100%">
                <Icon as={FiActivity} color="gray.500" />
                <Text fontSize={"xs"} color="gray.500" fontWeight="medium">
                  {props.item.display_clicks}
                </Text>
              </HStack>
            </Stack>
          </HStack>
          <Stack
            direction={{ base: "column", md: "row" }}
            spacing={{ base: 2, md: 1 }}
            align={"center"}
            justify={"flex-end"}
          >
            <Switch
              isDisabled={props.loading[props.item.id] || props.loading["link"]}
              defaultChecked={props.item.enabled}
              onChange={(e) =>
                props.onUpdate(props.item.id, {
                  enabled: e.target.checked,
                })
              }
              colorScheme="green"
            />
            <IconButton
              isDisabled={props.loading[props.item.id] || props.loading["link"]}
              onClick={() => props.onEdit(props.item)}
              variant="ghost"
              aria-label="edit link"
              icon={<FiEdit2 />}
            />
          </Stack>
        </HStack>
      </Box>
    </ListItem>
  );
};
